/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

interface ColumnCodeProps extends Pick<ColumnCommonProps, 'question' | 'alternativeCode' | 'preferredAltCodes'> {
  handleGoToQuestion?: () => void;
}

const getAltCode = (p: ColumnCodeProps) => {
  const { question, alternativeCode, preferredAltCodes } = p;
  const universalTracker = question.universalTracker;

  if (Array.isArray(preferredAltCodes)) {
    for (const code of preferredAltCodes) {
      if (universalTracker.hasAlternativeInfo(code)) {
        return code
      }
    }
  }

  return alternativeCode;
}

export const ColumnCode = (props: ColumnCodeProps) => {
  const { question, handleGoToQuestion } = props;


  const alternativeCode = getAltCode(props);
  const universalTracker = question.universalTracker;
  const questionTypeCode = universalTracker.getTypeCode(alternativeCode);
  const questionTypeName = universalTracker.getTypeName(alternativeCode);
  const tooltip = <>{questionTypeName}<br />{questionTypeCode}</>;

  return (
    <Column className='codeCol pl-3' truncate tooltip={tooltip} onClick={handleGoToQuestion}>
      {questionTypeCode}
    </Column>
  );
}
